import apiClient from "../libs/axios";
import { apiUrl } from "../constans";


const helper = {
    namespaced: true,

    state: {
        genres: [],
        countries: [],
        states: [],
        cities: [],
        zones: [],
        neighborhoods: [],
        documentType: [],
        roles: [],
        memberships: [],
        propertyStates: [],
        data: null
    },

    mutations: {
        setGenres(state, genres) {
            state.genres = genres;
        },
        setCountries(state, countries) {
            state.countries = countries;
        },
        setStates(state, states) {
            state.states = states;
        },
        setCities(state, cities) {
            state.cities = cities;
        },
          setZones(state, zones) {
            state.zones = zones;
        },
        setDocumentType(state, document_type) {
            state.documentType = document_type;
        },
        setNeighborhoods(state, neighborhoods) {
            state.neighborhoods = neighborhoods;
        },
        setRoles(state, roles) {
            state.roles = roles;
        },
        setMemberships(state, data) {
            state.memberships = data;
        },
        setPropertyStates(state, propertyStates) {
            state.propertyStates = propertyStates || [];
        },
        setData(state, data) {
            state.data = data
        }
    },

    getters: {
        getGenres(state) {
            return state.genres;
        },
        getCountries(state) {
            return state.countries;
        },
        getCities(state) {
            return state.cities;
        }
    },

    actions: {
        storeHelpers({ commit }) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/helpers`)
                    .then(response => {
                        const res = response.data.data
                        commit('setGenres', res.genders);
                        commit('setDocumentType', res.document_type)
                        commit('setCountries', res.countries);
                        commit('setRoles', res.roles);
                        commit('setMemberships', res.memberships);

                        resolve("genders");
                    })
                    .catch(error => {
                        reject(error);
                    });
            });

        },
        storeStates({ commit }, country) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/helpers-states/${country}`)
                    .then(response => {
                        const res = response.data
                        console.log("storeStates", res)
                        commit('setStates', res.data);
                        resolve(true);
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error);
                    });
            });

        },
        storeCities({ commit }, state) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/helpers-cities/${state}`)
                    .then(response => {
                        const res = response.data
                        commit('setCities', res.data);
                        resolve(true);
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error);
                    });
            });

        },


        storeZones({ commit }, cityId) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/helpers-zones/${cityId}`)
                    .then(response => {
                        const res = response.data;
                        commit('setZones', res.data);
                        resolve(true);
                    })
                    .catch(error => {
                        console.log(error);
                        reject(error);
                    });
            });
        },

        storeNeighborhoods({ commit }, neighborhoods) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/helpers-neighborhoods/${neighborhoods}`)
                    .then(response => {
                        const res = response.data
                        commit('setNeighborhoods', res.data);
                        resolve(true);
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error);
                    });
            });

        },

        storeRunCpanelCommant() {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/v2/run-cpanel`)
                    .then(response => {
                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });

        },

        // GET /auth/api-inmueble-state -> data.state_property: [{ id, name }]
        storePropertyStates({ commit }) {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/auth/api-inmueble-state`)
                    .then(response => {
                        const states = response.data.data?.state_property || [];
                        commit('setPropertyStates', states);
                        resolve(states);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });

        },

        storeRunAgentMetrocuadrado() {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/auth/metrocuadrado/agents`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });

        },

        storeExportUsersMemberships() {
            return new Promise((resolve, reject) => {
                apiClient.get(`${apiUrl}/helpert/export-memberships`, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'membresias.xlsx');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });

        },

        storeExportAllProperty() {
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/helpert/export-properties`, { responseType: 'arraybuffer' })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'inmuebles.xlsx'); // Nombre del archivo
                        document.body.appendChild(link);
                        link.click();
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });

        },

        storeRunGetPropertiesDomus({ commit }, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/v2/domus/properties`, data)
                    .then(response => {
                        commit('setNeighborhoods', response);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });

        },

        storeBarriosPortales({ commit }, formData)  {


            return new Promise((resolve, reject) => {
                apiClient.post(`${apiUrl}/helpert/import-barrios-portales`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then(response => {
                        commit('setNeighborhoods', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }

}

export default helper
